const getColumnBadgeNumber = (column) => {
  let result = 0
  if (column.filter?.operation) result++
  if (column.sorting?.direction) result++
  if (column.grouping) result++
  return result
}

export default getColumnBadgeNumber
